import { Dropdown } from '@arpeggi/ui'
import Button from '../../core/Button/Button'
import { usePackHolders } from '../hooks'

export const HoldersDropdown = () => {
  const { data, bindSelect, label, loading } = usePackHolders()
  return (
    <Dropdown.Root>
      <Dropdown.Trigger>
        <Button big type="dark" disabled={loading}>
          {label}
        </Button>
      </Dropdown.Trigger>
      <Dropdown.Portal>
        <Dropdown.Content>
          {data?.map((mc) => (
            <Dropdown.Item key={mc.id} onClick={bindSelect(mc)}>
              {mc.title}
            </Dropdown.Item>
          ))}
        </Dropdown.Content>
      </Dropdown.Portal>
    </Dropdown.Root>
  )
}
